import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: theme.spacing(2),
    marginBottom: 8,
    padding: 16,
    borderRadius: 8,
    position: 'relative',
    background: theme.palette.grey[200]
  },
  facilityContainer: { display: 'flex', flexWrap: 'wrap' },
  facilityText: { fontWeight: 500, color: theme.palette.info.main },
  btn: {
    textTransform: 'none',
    padding: 0,
    fontSize: 14,
    marginLeft: 4,
    display: 'inline',
    minWidth: 'auto',
    color: theme.palette.info.main
  },
  roomImage: {
    width: 197,
    height: 147,
    objectFit: 'cover',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100
    }
  },
  counter: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content',
    background: theme.palette.grey[900],
    position: 'absolute',
    top: 10,
    left: 10,
    padding: '4px 8px',
    borderRadius: 6,
    opacity: 0.6
  },
  photoIcon: { width: 14, height: 14, marginRight: 2 },
  iconText: {
    lineHeight: 1,
    fontWeight: 600,
    color: theme.palette.primary.contrastText,
    marginLeft: 6
  },
  header: {
    width: '100%',
    display: 'flex',
    marginBottom: 8
  },
  headerToolTip: {
    padding: 4,
    borderBottom: `1px dashed ${theme.palette.grey[400]}`
  },
  imageContainer: {
    width: 197,
    height: 147,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      width: 100,
      height: 100
    }
  },
  roomName: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: 16,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '50%'
    }
  },
  middle: {
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8
  },
  middleBottom: { display: 'grid', gridTemplateColumns: '1.5fr 1fr' },
  counterContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end'
  },
  iconTextRow: {
    display: 'flex',
    marginLeft: 4,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginLeft: 0
    }
  },
  iconTextRowSmall: {
    flexDirection: 'row',
    marginBottom: 8
  },
  textafterIcon: {
    lineHeight: '18px',
    fontWeight: 600,
    color: theme.palette.grey[700],
    marginLeft: 4
  },
  smallIcon: {
    fontSize: 16,
    paddingBottom: 0
  },
  facilityList: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '80%'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.error.main,
    borderRadius: 6,
    position: 'absolute',
    top: 16,
    right: 16
  },
  facilitySection: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column'
  },
  countContainer: {
    display: 'flex',
    width: '20%',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      width: '40%'
    }
  },
  addOnRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing(1, 0)
  },
  counterControl: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  greenText: {
    color: '#4caf50',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600
  },
  deleteButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 42,
    height: 42,
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.down('sm')]: {
      width: 32,
      height: 32
    }
  },
  ratePolicy: { display: 'flex', alignItems: 'center', marginRight: 16 },
  redIcon: {
    color: theme.palette.error.main,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    marginRight: 4
  },
  redtext: {
    color: theme.palette.error.main,
    marginRight: 4,
    fontWeight: 600,
    marginTop: 0.5
  },
  infoIcon: {
    marginRight: 6,
    fontSize: 14,
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  greenIcon: {
    color: theme.palette.secondary.main,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    marginRight: 4
  },
  yellowIcon: {
    color: theme.palette.warning.main,
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14
    },
    marginRight: 4
  },
  yellowText: {
    color: theme.palette.warning.main,
    marginRight: 4,
    fontWeight: 600
  },
  greenIconText: {
    color: theme.palette.secondary.main,
    marginRight: 10,
    fontWeight: 600,
    alignSelf: 'center'
  },
  blueIcon: {
    color: theme.palette.info.main,
    fontSize: 20,
    marginRight: 4,
    alignSelf: 'center'
  },
  blueText: {
    color: theme.palette.info.main,
    marginRight: 4,
    fontWeight: 600
  },
  sub1: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  sub2: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginTop: 8
  },
  sub: {
    fontWeight: 600,
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    },
    color: theme.palette.text.primary
  },
  rateContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 8,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: 8
    }
  },
  addOnContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '10px 0px',
    marginTop: 18,
    borderRadius: 6
  },
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    background: theme.palette.grey[300],
    padding: '6px 8px',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px'
  },
  greyText: {
    fontWeight: 600,
    color: theme.palette.grey[700],
    marginBottom: 8
  },
  boardTypeText: {
    fontWeight: 600,
    color: theme.palette.grey[700]
  },
  iconPad: { padding: 4 },
  verticalAlign: {
    display: 'flex',
    verticalAlign: 'middle',
    fontSize: 18,
    fontWeight: 600,
    lineHeight: '1.4rem',
    color: theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      marginBottom: 12
    }
  },
  icon: { marginRight: 4, fontSize: 20 },
  headerBottom: {
    display: 'grid',
    gridTemplateColumns: '3fr 1fr',
    marginLeft: 4,
    gap: 8,
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'none'
    }
  },
  checkContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start'
    }
  },
  check: { display: 'flex', flexDirection: 'row' },
  dateLabel: {
    color: theme.palette.grey[600],
    marginRight: 6,
    fontWeight: 500
  },
  dateValue: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.default,
    padding: 4,
    width: '100%'
  },
  toolTipText: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    direction: 'ltr'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '6px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11
    },
    gap: 6,
    marginTop: 4,
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: 12
    // whiteSpace: 'pre-line',
    // unicodeBidi: 'embed'
  },
  dotText: {
    position: 'relative',
    paddingLeft: 8,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -2,
      top: 7,
      transform: 'translateY(-50%)',
      width: 6,
      height: 6,
      marginRight: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[600]
    }
  },
  mainDeadLineText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    fontSize: '11px',
    color: theme.palette.text.primary
  },
  deadLineTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    marginTop: '2px',
    fontSize: '11px',
    color: theme.palette.text.primary
  },
  toolTip: {
    background: theme.palette.grey[300],
    minWidth: '320px',
    padding: 12
  },
  arrow: { color: theme.palette.grey[100] },
  facilityAndCounter: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
      marginTop: '8px'
    }
  },
  circularProgress: {
    color: theme.palette.background.default,
    alignSelf: 'center'
  }
}))
